import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DropZoneComponent from '../../../components/common/DropZone';
import { IMG_SCALE_SIZE } from '../../../utility/constants';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import { BodyText } from '@paypalcorp/pp-react-text';
import CropImage from './CropImage';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { Button } from '@paypalcorp/pp-react-buttons';
import { TrashIcon } from '@paypalcorp/pp-react-icons';
import { Alert } from '@paypalcorp/pp-react-alert';
import { change } from 'redux-form';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC, SCREEN } from '../../utilsV3/fptiConstants';

const DropzoneImageHandle = ({
  dispatch,
  uploadImage,
  getContent,
  closeModal,
  bannerImageUrl,
  isMobile,
}) => {
  const imageHandle = getContent('modal.imageHandle');
  const saveButtonImage = getContent('modal.saveButtonImage');
  const deleteButton = getContent('modal.deleteButton');

  const [imageData, setImageData] = useState();
  const [dropzoneError, setDropzoneError] = useState('');

  useEffect(() => {
    if (bannerImageUrl) {
      setImageData({
        src: bannerImageUrl,
        name: bannerImageUrl.split('/').pop(),
      });
    }
  }, []);

  const handleImageDropzone = (image) => {
    setDropzoneError('');
    if (image.hasError) {
      trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
        error_code: 'IMAGE_DROPZONE_ERROR',
        error_desc: 'banner_image',
        error_detail: image.error,
        screen: SCREEN.EXPERIENCE_SETUP,
      });
      setDropzoneError(image.error);
    } else {
      setImageData(image);
      trackEventWithData(FPTI_SPEC.UPLOAD_BACKGOURND_IMG_MODAL_IMAGE_UPDATED);
    }
  };

  const deleteImage = () => {
    dispatch(change(BTN_FACTORY_V3_FORM, 'bannerImageUrl', ''));
    closeModal();
  };

  const handleSaveButtonClick = () => {
    trackEventWithData(FPTI_SPEC.UPLOAD_BACKGOURND_IMG_MODAL_SAVE_CL);
    deleteImage();
  };

  return (
    <div className="image-handler">
      {!imageData ? (
        <>
          <DropZoneComponent
            showPreviewInDropzone={false}
            onChange={handleImageDropzone}
            imgWidth={IMG_SCALE_SIZE.WIDTH_BANNER}
            onlyEditButton={false}
          />
          {dropzoneError && (
            <Alert type="warning" className="dropzone-error">
              {dropzoneError}
            </Alert>
          )}
          <Button onClick={handleSaveButtonClick} className="banner-save-img">
            {saveButtonImage}
          </Button>
        </>
      ) : (
        <>
          <BodyText strong>{imageHandle}</BodyText>
          <div className="image-name-delete">
            {imageData.name && (
              <BodyText className="dropzone-image-name">
                {imageData.name}
              </BodyText>
            )}
            <IconButton
              onClick={() => setImageData()}
              svgIconComponent={TrashIcon}
              className={'delete-img'}
            >
              {deleteButton}
            </IconButton>
          </div>

          <CropImage
            imgUrl={imageData.src}
            uploadImage={uploadImage}
            getContent={getContent}
            closeModal={closeModal}
            dispatch={dispatch}
            imageChange={handleImageDropzone}
            widthBanner={IMG_SCALE_SIZE.WIDTH_BANNER}
            isMobile={isMobile}
          />
        </>
      )}
    </div>
  );
};

DropzoneImageHandle.propTypes = {
  dispatch: PropTypes.func,
  uploadImage: PropTypes.func,
  getContent: PropTypes.func,
  closeModal: PropTypes.func,
  bannerImageUrl: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default DropzoneImageHandle;
